require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-key-standards-to-preserve-under-an-integration-of.json") })
        }
      }, "path---en-us-update-key-standards-to-preserve-under-an-integration-of");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-key-standards-to-preserve-under-an-integration-of!./.cache/json/en-us-update-key-standards-to-preserve-under-an-integration-of.json
// module id = 770
// module chunks = 231608221292675